import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { SubmitNewBusinessComponent } from '../submit-new-business/submit-new-business.component';
import { Airport } from '../models/airport.model';
import { MatDialog } from '@angular/material';
var BusinessListingComponent = /** @class */ (function () {
    function BusinessListingComponent(businessManagerService, _matDialog) {
        this.businessManagerService = businessManagerService;
        this._matDialog = _matDialog;
        this.isFlightDeckAdmin = false;
    }
    BusinessListingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BusinessListingComponent.prototype, "sortedFBOs", {
        get: function () {
            if (!this.isFlightDeckAdmin) {
                return this.businesses
                    .filter(function (b) { return b.isFbo; })
                    .filter(function (fbo) { return !fbo.hideBusiness; })
                    .filter(function (fbo) { return !fbo.notApproved; })
                    .sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            }
            return this.businesses
                .filter(function (b) { return b.isFbo; })
                .sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessListingComponent.prototype, "sortedFlightTraining", {
        get: function () {
            if (!this.isFlightDeckAdmin) {
                return this.businesses
                    .filter(function (b) { return b.flightTraining; })
                    .filter(function (fbo) { return !fbo.hideBusiness; })
                    .filter(function (fbo) { return !fbo.notApproved; })
                    .sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            }
            return this.businesses
                .filter(function (b) { return b.flightTraining; })
                .sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessListingComponent.prototype, "sortedBusinesses", {
        get: function () {
            if (!this.isFlightDeckAdmin) {
                return this.businesses
                    .filter(function (b) { return !b.isFbo; })
                    .filter(function (b) { return !b.flightTraining; })
                    .filter(function (bus) { return !bus.hideBusiness; })
                    .filter(function (fbo) { return !fbo.notApproved; })
                    .sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            }
            return this.businesses
                .filter(function (b) { return !b.isFbo; })
                .filter(function (b) { return !b.flightTraining; })
                .sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    BusinessListingComponent.prototype.openSubmitNewBusinessDialog = function (facilityType) {
        var dialogRef = this._matDialog.open(SubmitNewBusinessComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                airport: this.airport,
                facilityType: facilityType
            }
        });
    };
    return BusinessListingComponent;
}());
export { BusinessListingComponent };
